// src/shared/services/types.js
export const ErrorTypes = {
    AUTH: 'AUTH_ERROR',
    NOT_FOUND: 'NOT_FOUND',
    VALIDATION: 'VALIDATION_ERROR',
    SERVER: 'SERVER_ERROR'
};

export class ServiceError extends Error {
    constructor(type, message) {
        super(message);
        this.type = type;
    }
}
